import { AxiosResponse } from 'axios';


import { api } from '../../http';
import {
  AvgTransportSpeedApiResponse,
  AvgTransportSpeedUI,
  BaseFilter,
  ObjectForSelection,
  PageRequest,
  PageResponse,
} from '../../types/interfaces';

import { ApiResponse } from './interfaces';

export const AvgTransportSpeedService = {
  getAvgTransportSpeed(
    params: PageRequest & {
      sortBy?: string;
      sortDirection?: string;
      parsedFilters?: BaseFilter[];
      fillers?: string;
    }
  ): Promise<AxiosResponse<ApiResponse<PageResponse<AvgTransportSpeedUI>>>> {
    const searchParams = new URLSearchParams();
    Object.keys(params).forEach((key) => {
      if (params[key]) {
        searchParams.append(key, String(params[key]));
      }
    });

    return api.get<ApiResponse<PageResponse<AvgTransportSpeedUI>>>('AvgTransportSpeed', {
      params: searchParams
    });
  },

  updateAvgTransportSpeed(
    id: number, 
    AvgTransportSpeed: AvgTransportSpeedUI
  ): Promise<AxiosResponse<ApiResponse<AvgTransportSpeedUI>>> {
    return api.put<ApiResponse<AvgTransportSpeedUI>>(
      `AvgTransportSpeed/${id}`,
      AvgTransportSpeed
    );
  },

  deleteAvgTransportSpeed(id: number): Promise<AxiosResponse<ApiResponse<null>>> {
    return api.delete<ApiResponse<null>>(`AvgTransportSpeed/${id}`); 
  },

  createAvgTransportSpeed(
    AvgTransportSpeed: AvgTransportSpeedUI
  ): Promise<AxiosResponse<ApiResponse<AvgTransportSpeedUI>>> {
    return api.post<ApiResponse<AvgTransportSpeedUI>>('AvgTransportSpeed', AvgTransportSpeed);
  }, 
  getAvgTransportSpeedForSelection(): Promise<AxiosResponse<AvgTransportSpeedApiResponse>> {
    return api.get<AvgTransportSpeedApiResponse>('AvgTransportSpeed', {
      params: { ForSelection: 'true' }
    });
  },

  getForSelection(): Promise<AxiosResponse<ObjectForSelection[]>> {
    return api
      .get<ApiResponse<ObjectForSelection[]>>('AvgTransportSpeed', {
        params: { ForSelection: 'true' }
      })
      .then((resp) => ({
        ...resp,
        data: resp.data.isSuccess ? resp.data.value ?? [] : []
      }));
  }
};
